export var RatingScale;
(function (RatingScale) {
    RatingScale["ONE_TO_TEN"] = "oneToTen";
    RatingScale["ONE_TO_THREE"] = "oneToThree";
    RatingScale["YES_NO"] = "yesNo";
})(RatingScale || (RatingScale = {}));
export var FormStatus;
(function (FormStatus) {
    FormStatus["DRAFT"] = "draft";
    FormStatus["PUBLISHED"] = "published";
})(FormStatus || (FormStatus = {}));
export var PlayerEvaluationStatus;
(function (PlayerEvaluationStatus) {
    PlayerEvaluationStatus["Draft"] = "draft";
    PlayerEvaluationStatus["Published"] = "published";
})(PlayerEvaluationStatus || (PlayerEvaluationStatus = {}));
